import {TYPE_COLUMN_HIGH_CHART, TYPE_COLUMN_TOTAL} from '@/containers/E4ImpactMBA/resources/config-schema';
import {IConfigSchema} from '@/containers/E4ImpactProjects/resources/config-schema';
import {numberOfProjectsTotalCalculation} from './total-calculations/number-of-projects-total-calculation';
import {entrepreneursEnrolledPerCountryChartCalculation} from './chart-calculations/entrepreneurs-enrolled-per-country-chart-calculation';
import {womenEnrolledTotalCalculation} from './total-calculations/women-enrolled-total-calculation';
import {under30EnrolledTotalCalculation} from './total-calculations/under-30-enrolled-total-calculation';
import {typeEducationalBackgroundChartCalculation} from './chart-calculations/type-educational-background-chart-calculation';
import {participantsStatusChartCalculation} from './chart-calculations/participants-status-chart-calculation';
import {careerProfileChartCalculation} from './chart-calculations/career-profile-chart-calculation';
import {typeSectorChartCalculation} from './chart-calculations/type-sector-chart-calculation';
import {specialtyAgrifoodSectorChartCalculation} from './chart-calculations/specialty-agrifood-sector-chart-calculation';
import {specialtyProcessingSectorChartCalculation} from './chart-calculations/specialty-processing-sector-chart-calculation';
import {specialtyFashionAndTextileSectorChartCalculation} from './chart-calculations/specialty-fashion-and-textile-sector-chart-calculation';
import {mainPurposesBusinessChartCalculation} from './chart-calculations/main-purposes-business-chart-calculation';
import {socialImpactPurposeTotalCalculation} from './total-calculations/social-impact-purpose-total-calculation';
import {mainSocialImpactPurposesChartCalculation} from './chart-calculations/main-social-impact-purposes-chart-calculation';
import {numberOfEntrepreneursEnrolledTotalCalculation} from './total-calculations/number-of-entrepreneurs-enrolled-total-calculation';

export const configSchema = (props: any): IConfigSchema => ([
    {
        rows: [
            {
                columns: [
                    {
                        title: 'Number of Projects',
                        typeChart: TYPE_COLUMN_TOTAL,
                        transformData: numberOfProjectsTotalCalculation(props),
                    },
                    {
                        title: 'Numbers of entrepreneurs enrolled',
                        typeChart: TYPE_COLUMN_TOTAL,
                        transformData: numberOfEntrepreneursEnrolledTotalCalculation(props),
                    }
                ]
            },
            {
                columns: [
                    {
                        title: 'Entrepreneurs enrolled per country',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: entrepreneursEnrolledPerCountryChartCalculation(props),
                    }
                ]
            },
            {
                columns: [
                    {
                        title: '% of women enrolled',
                        typeChart: TYPE_COLUMN_TOTAL,
                        transformData: womenEnrolledTotalCalculation(props),
                    },
                    {
                        title: '% of under 30 enrolled',
                        typeChart: TYPE_COLUMN_TOTAL,
                        transformData: under30EnrolledTotalCalculation(props),
                    }
                ]
            },
            {
                columns: [
                    {
                        title: 'Type of educational background',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: typeEducationalBackgroundChartCalculation(props),
                    }
                ]
            },
            {
                columns: [
                    {
                        title: '% of participants that successfully concluded the program and dropouts',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: participantsStatusChartCalculation(props),
                    },
                    {
                        title: 'Career Profile',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: careerProfileChartCalculation(props),
                    }
                ]
            },
            {
                columns: [
                    {
                        title: 'Type of Sector',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: typeSectorChartCalculation(props),
                    },
                ]
            },
            {
                columns: [
                    {
                        title: 'Specialty of the agrifood sector',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: specialtyAgrifoodSectorChartCalculation(props),
                    },
                ]
            },
            {
                columns: [
                    {
                        title: 'Specialty of the food processing sector',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: specialtyProcessingSectorChartCalculation(props),
                    },
                    {
                        title: 'Specialty of the fashion and textile sector',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: specialtyFashionAndTextileSectorChartCalculation(props),
                    },
                ]
            },
        ]
    },
    {
        titleSection: {
            title: 'Business purpose'
        },
        rows: [
            {
                columns: [
                    {
                        title: 'Entrepreneurs with social impact purpose (option 3 or 4)',
                        typeChart: TYPE_COLUMN_TOTAL,
                        transformData: socialImpactPurposeTotalCalculation(props),
                    },
                ]
            },
            {
                columns: [
                    {
                        title: 'Main purposes of the business',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: mainPurposesBusinessChartCalculation(props),
                    },
                    {
                        title: 'Main social impact purpose',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: mainSocialImpactPurposesChartCalculation(props),
                    },
                ]
            },
        ]
    }
]);